// @flow

import React from "react";
import { Router, Route, Redirect, browserHistory } from "react-router";

import { Template, Signup, User, ErrorPage, Forgot, Search, Token, Admin, Mobile } from "../src/conference/views";

const PageRoute = (): React$Element<*> => (
  <Router history={browserHistory}>
    <Route component={Template} path='/:conference' >
      <Route path='signup' component={Signup} />
      <Route path='forgot' component={Forgot} />
      <Route path='user/:token' component={Token} />
      <Route path='profile' component={User} />
      <Route path='search' component={Search} />
      <Route path='admin' component={Admin} />
      <Route path='mobileaccess/:token' component={Mobile} />
    </Route>
    <Route path='/' component={ErrorPage} />
    <Route path="/:conference/*" component={ErrorPage} />
  </Router>
);

export default PageRoute;



// WEBPACK FOOTER //
// ./src/PageRoute.js